import script from "./PostBreadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostBreadcrumb.vue?vue&type=script&setup=true&lang=ts"

import "../../assets/css/post-breadcrumb.css?vue&type=style&index=0&id=de6734b4&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de6734b4"]])

export default __exports__